import { $ } from '../../vendor/jquery';
import _ from 'underscore';
import { moment } from '../../vendor/moment';
import { glom } from './glom';
import { Log } from '../AuxillaryService/Log';
import { labOptions, Signage } from '.';
import { Aux } from '../AuxillaryService';
import { Scheduler } from '../Utility/Scheduler';
import { ReachAPI } from '../ReachApi';
import { createStreamSchedule } from '../StreamSchedule';
import { schedulePlayerRestart } from './playerFunctions';
import { ImageCache } from '../Cache/ImageCache';
import { FontCache } from '../Cache/FontCache';
import * as Debugging from '../Debugging';
import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';
import { detectUrlAnchorOverrides, isInsideCms } from './urlOverrides';
import {
    platform,
    supportsPlayerControl,
    supportsNtp,
    supportsNtpClockSkew,
    supportsRootStorageFiles,
    supportsScreenshot,
    supportsSystemUpdate,
    supportsHeartbeat,
    supportsReload,
    supportsReach,
} from '../Platform';
import { getDisplays } from '../Display';
import { configureReachApiV2 } from '../ReachApiV2';
import { configureReachIam } from '../ReachIam';
import { initializeEmergencyAlerts } from '../EmergencyAlerts/EmergencyAlerts';
import { isNullish } from '../Utility/Nullish';

/**
 * Scale Signage either actively based on the window's size or one time based on
 * a URL anchor override.
 */
function initializeWindowScaling(): void {
    const setWindowScale = function (scale: string): void {
        //set display scale
        $('html').css({
            transform: 'scale(' + scale + ')',
            'transform-origin': '0 0',
        });
    };

    if (glom.windowScale === 'auto') {
        window.onresize = function (): void {
            const displays = [
                {
                    selector: '.player-inactive',
                    width: 1920,
                    height: 1080,
                },
            ].concat(
                getDisplays().map((d) => ({
                    selector: `#display_${d.id}`,
                    width: d.width || glom.playerXDimension,
                    height: d.height || glom.playerYDimension,
                }))
            );

            for (const idx in displays) {
                const display = displays[idx];

                const selector = display.selector;
                const width = display.width;
                const height = display.height;

                const playerRatio = width / height;

                const xExceededByNormalized = (window.innerWidth - width) / playerRatio;
                const yExceededByNormalized = (window.innerHeight - height) / playerRatio;

                let displayScale = null;
                if (xExceededByNormalized < yExceededByNormalized) {
                    displayScale = window.innerWidth / width;
                } else {
                    displayScale = window.innerHeight / height;
                }

                glom.effectiveWindowScale = displayScale;

                $(selector).css({
                    transform: `scale(${displayScale})`,
                    'transform-origin': '0 0',
                });
            }
        };

        window.onresize(new FocusEvent('Forced'));
    } else {
        glom.effectiveWindowScale = parseFloat(glom.windowScale);
        setWindowScale(glom.windowScale);
    }
}

/**
 * Code called after Signage has gotten its configuration from the API.
 */
async function main(): Promise<void> {
    'use strict';

    const thePlatform = platform();

    // <editor-fold desc="Detect URL Anchor Overrides">
    detectUrlAnchorOverrides();
    // </editor-fold>

    // <editor-fold desc="Apply Player-Wide Settings">

    //set moment locale
    moment.locale(glom.locale);

    initializeWindowScaling();

    if (!isInsideCms() && !glom.allowCursor) {
        // TODO: use CSS class rather than inline styles
        $('*').css('cursor', 'none');
    }

    if (glom.titleId) {
        glom.originalTitle = document.title;
        document.title = `${glom.originalTitle} - {${glom.titleId}:${Date.now()}}`;
    }

    if (thePlatform.setVolume) {
        thePlatform.setVolume(100, 0);
    }

    // </editor-fold>

    // <editor-fold desc="Initialize Core Services">

    // </editor-fold>

    if (thePlatform.sendSignageReadySignal !== undefined) {
        await thePlatform.sendSignageReadySignal();
    }

    if (thePlatform.setOrientation !== undefined) {
        Log.Info(`Set screen orientation (${Signage.orientation})`, null, __fileline);
        await thePlatform.setOrientation(Signage.orientation);
    }

    // <editor-fold desc="Initialize Auxiliary Services">

    Aux.Discover(function () {
        Aux.Service('ImageCache')
            .waitForDiscoveryComplete()
            .then(function () {
                Aux.Service('ImageCache').prefetchAll(glom.prefetchAssets);
            });

        Aux.Service('Network').registerCallback(
            'statusChanged',
            'playerNetworkMonitor',
            function (newStatus: string) {
                const img = $('#networkStatusIndicator');
                newStatus = newStatus.toLowerCase();

                let url = undefined;
                switch (newStatus) {
                    case 'ok':
                        url = '/images/network-status-ok.png';
                        break;
                    case 'degraded':
                        url = '/images/network-status-degraded.png';
                        break;
                    case 'down':
                        url = '/images/network-status-down.png';
                        break;
                }

                if (typeof url !== 'undefined') {
                    Aux.Service('ImageCache')
                        .loadImage(url, img)
                        .then(function () {
                            if (_.contains(glom.showNetworkStates, newStatus)) {
                                img.show();
                            } else {
                                img.hide();
                            }
                        });
                }
            }
        );

        //run the scheduler asynchronously
        Scheduler.RunAsync();

        //check system memory usage every 15 seconds
        /*
        if ( window.performance && window.performance.memory ) {
            Log.Info( 'Schedule performance check', null, __fileline );
            Scheduler
                .New()
                .Called( 'checkMemoryUsage' )
                .HasAction( function() {
                    // `performance.memory` is a non-standard extension added in
                    // Chrome.
                    const memInfo = window.performance.memory;

                    const memUsagePercent = 100 * memInfo.totalJSHeapSize
                        / memInfo.jsHeapSizeLimit;

                    //presumably we should request a restart from CMS if memory
                    //usage is getting high
                })
                .RunEvery( 15, 'seconds' );
        }
        */

        if (glom.playerUuid) {
            Scheduler.New()
                .Called('setLastOnline')
                .HasAction(async function () {
                    const systemData = await Signage.SystemInformation();

                    let remoteSupportDeviceId: string | undefined;
                    if (supportsReach(thePlatform)) {
                        try {
                            remoteSupportDeviceId = await thePlatform.getRemoteSupportDeviceId();
                        } catch (err) {
                            //not a warning/error: some platforms don't have
                            //remote support, some players don't have remote
                            //support installed intentionally
                            Log.Info(
                                "Failed to retrieve this player's Remote Support Device ID.",
                                null,
                                __fileline,
                                err
                            );
                        }
                    }

                    let lastRestart: string | undefined;
                    try {
                        lastRestart =
                            (await thePlatform.getNamedValue('last_restart')) ?? undefined;
                    } catch (err) {
                        Log.Warning(
                            'Failed to retrieve `last_restart` NamedValueCache variable.',
                            null,
                            __fileline,
                            err
                        );
                    }

                    await ReachAPI.player.putStatusOnline(
                        glom.playerUuid,
                        systemData.player.version,
                        systemData.signage.version,
                        remoteSupportDeviceId,
                        systemData.player.timelineId,
                        lastRestart
                    );
                })
                .RunEvery(15, 'minutes');
        }

        if (Signage.schedules.length > 0) {
            createStreamSchedule(Signage.schedules, Signage.comPort, Signage.displayMake);
        }
    });

    // </editor-fold>

    // <editor-fold desc="Set Player Automatic Restart">

    if (glom.dailyRestartWindow.begin && glom.dailyRestartWindow.end) {
        schedulePlayerRestart(glom.dailyRestartWindow.begin, glom.dailyRestartWindow.end);
    } else {
        Log.Notice('Player daily restart not configured', null, __fileline);
    }

    // </editor-fold>

    // <editor-fold desc="ImageCache MutationObserver">
    ImageCache.startObserver();
    // </editor-fold>

    // <editor-fold desc="FontCache MutationObserver">
    FontCache.startObserver();
    // </editor-fold>

    // <editor-fold desc="IndexedDB Records Purge">
    // TODO: Re-think Cache Purge
    //LocalCache.schedulePurge();
    // </editor-fold>

    // <editor-fold desc="Send System Configuration Report">
    // There is no reason this needs to wait, I'm just tired of everything
    // running at startup
    setTimeout(Signage.PostSystemConfiguration, 60 * 1000);
    // </editor-fold>

    // <editor-fold desc="Beta Labs">
    // Show Video Info Overlay on startup (if enabled)
    if (labOptions.instance.get('enableVideoInfoOverlayOnStartUp')) {
        setTimeout(function () {
            Debugging.VideoInfo.show();
        }, labOptions.instance.get('delayVideoInfoOverlayOnStartUp') * 1000);
    }

    // Start Video Playback Monitor on startup (if enabled)
    if (
        labOptions.instance.get('enableVideoPlaybackMonitor') ||
        Debugging.isSelectedForRollout(0, 5)
    ) {
        setTimeout(function () {
            Debugging.MonitorCollection.start();
        }, 30 * 1000);
    }
    // </editor-fold>

    // <editor-fold desc="Test IndexedDb Write">
    Debugging.IndexedDb.runDatabaseWriteTest();
    // </editor-fold desc="Test IndexedDb Write">

    // <editor-fold desc="Player Capabilities">
    //set player capabilities based on platform.
    ReachAPI.player.putPlatformCapabilities(
        glom.playerUuid,
        JSON.stringify({
            refresh: supportsReload(thePlatform),
            reboot: supportsPlayerControl(thePlatform),
            screenshot: supportsScreenshot(thePlatform),
            retrieveRootStorageFiles: supportsRootStorageFiles(thePlatform),
        })
    );
    // </editor-fold desc="Player Capabilities">

    // <editor-fold desc="Control Player System">

    if (supportsSystemUpdate(thePlatform)) {
        try {
            await thePlatform.schedulePlatformUpdate({
                isEnabled: isNullish(Signage.platformUpdateEnabled)
                    ? true
                    : Signage.platformUpdateEnabled === 'true',
                day: Signage.platformUpdateDay || 'sunday',
                time: Signage.platformUpdateTime || '00:00:00',
                lastUpdated: Signage.lastPlatformUpdateDate || null,
            });
        } catch (e) {
            Log.Warning('Failed to schedule a system update: ' + String(e), null, __fileline);
        }
    }

    if (supportsNtp(thePlatform)) {
        if (Signage.ntpEnabled) {
            const intervalInHours = 4;
            const intervalInSeconds = intervalInHours * 60 * 60;
            Log.Debug(
                `Enable NTP [server:${Signage.ntpServer}, interval:${intervalInSeconds}]`,
                null,
                __fileline
            );

            if (supportsNtpClockSkew(thePlatform)) {
                await thePlatform.setNtpClockSkew(Signage.ntpClockSkew);
            }
            thePlatform
                .enableNtp(Signage.ntpServer, intervalInSeconds)
                .catch(function (error: Error) {
                    Log.Error(
                        'Failed to enable NTP synchronization: ' + error.toString(),
                        null,
                        __fileline
                    );
                });
        } else {
            Log.Debug('Disable NTP', null, __fileline);
            thePlatform.disableNtp().catch(function (error: Error) {
                Log.Error(
                    'Failed to disable NTP synchronization: ' + error.toString(),
                    null,
                    __fileline
                );
            });
        }
    }

    // Initialize emergency alerts after signage configuration is available
    initializeEmergencyAlerts();

    /**
     * Lets the Player Software know that the application is running and
     * hasn't crashed
     *
     * NOTE: Should be the last bit of JavaScript to run
     */
    try {
        if (supportsHeartbeat(thePlatform)) {
            await thePlatform.startSendingHeartbeat();
        }
    } catch (e) {
        Log.Warning('Failed to send heartbeat: ' + String(e), null, __fileline);
    }

    // </editor-fold>

    /**
     * Add components required by Vue
     */
    Vue.use(VueApexCharts);
}

/**
 * Main call to initialize Signage
 */
async function initializeSignage(): Promise<void> {
    try {
        configureReachIam();
        configureReachApiV2();
        await Signage.Initialize();
        await Signage.ready();
        Log.Info('Initialize Signage', null, __fileline);
        await main();
    } catch (error) {
        let message;

        if (error instanceof Error) {
            message = error.toString();
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const errorData = error.data || {};
            if (
                errorData.API &&
                errorData.API.jqXHR.responseJSON &&
                errorData.API.jqXHR.responseJSON.status &&
                errorData.API.jqXHR.responseJSON.status === 'ERROR'
            ) {
                message += ` -- ${errorData.API.jqXHR.responseJSON.message}`;
            }
        } else {
            message = 'Unknown Error';
        }

        // failed (TODO: add log_code and send to `signage/notice` endpoint)
        Log.Error('Failed to initialize Signage', null, __fileline, {
            message: message,
            errorResponse: error,
        });

        const messageNode = document.createTextNode(message);

        document.body.style.backgroundColor = 'black';
        document.body.style.color = 'white';

        document.body.appendChild(messageNode);

        // re-throw for debugging
        throw error;
    }
}

export { initializeSignage };
